export const RATING_LABELS = [
    '',
    'Almost there',
    'OK',
    `Enjoyable`,
    'Great',
    'Incredible!'
]
